module.exports = __webpack_public_path__ + "img/xtb_old.e5149f38.png";